<div id="nav" [class.extended]="menuActive">
  <button class="menu-toggle" [class.active]="menuActive" type="button" (click)="toggleMenuActive()">
    <span class="menu-toggle-inner"></span>
  </button>
  <div class="nav-body">
    <div id="nav-headline" class="h3" routerLink="/{{nav.component}}">{{nav.headline}}</div>
    <div id="nav-accordion">
      @for (node of nav.tree; track node; let i = $index) {
        <div>
          @if (node.requiredAuthority == null || userService.hasRequiredAuthority(node.requiredAuthority) ) {
            @if (!node.fragment) {
              <a id="heading{{i}}"
                (click)="node.tree && node.tree.length > 0? false : menuInactive();"
                class="{{(node.tree && node.tree.length > 0) ? 'accordion-headline' : 'accordion-headline-no-children'}} collapsed"
                routerLink="{{node.path ? '/'+node.path : ''}}"
                data-toggle="collapse"
                attr.data-target="#collapse{{i}}"
                aria-expanded="true"
                attr.aria-controls="collapse{{i}}"
                [class.active]="active == node.path && active != 'dashboard' && node.path != null"
                attr.data-cy="nav-item-{{node.dataCy}}">{{node.navLinkName}}
              </a>
            }
            @if (node.fragment) {
              <a id="heading{{i}}"
                class="{{(node.tree && node.tree.length > 0) ? 'accordion-headline' : 'accordion-headline-no-children'}} collapsed"
                routerLink="{{node.path ? '/'+node.path+'/' : ''}}"
                [fragment]="node.fragment"
                data-toggle="collapse"
                attr.data-target="#collapse{{i}}"
                aria-expanded="true"
                attr.aria-controls="collapse{{i}}"
                [class.active]="active == node.path && active != 'dashboard' && node.path != null"
                attr.data-cy="nav-item-{{node.dataCy}}">{{node.navLinkName}}
              </a>
            }
            @if (node.tree && node.tree.length > 0) {
              <ul id="collapse{{i}}" class="collapse" attr.aria-labelledby="heading{{i}}"
                data-parent="#nav-accordion"
                >
                <!--<ul *ngIf="node.tree && node.tree.length > 0">-->
                @for (childNode of node.tree; track childNode) {
                  @if (childNode.requiredAuthority == null || userService.hasRequiredAuthority(childNode.requiredAuthority) ) {
                    <li
                      id="childNode{{i}}">
                      <a routerLink="/{{childNode.path}}"
                        [class.active]="active == childNode.path && active != 'dashboard'"
                        attr.data-cy="nav-item-{{childNode.dataCy}}">
                        {{childNode.navLinkName}}
                      </a>
                    </li>
                  }
                }
              <!--</ul>-->
            </ul>
          }
        }
      </div>
    }
  </div>
</div>
</div>
